// source: tracking_session_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var timestamp_proto_pb = require('./timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
goog.exportSymbol('proto.TrackingLocationDelta', null, global);
goog.exportSymbol('proto.TrackingLocationDeltaList', null, global);
goog.exportSymbol('proto.TrackingLocationDto', null, global);
goog.exportSymbol('proto.TrackingSessionDto', null, global);
goog.exportSymbol('proto.TrackingSessionEvent', null, global);
goog.exportSymbol('proto.TrackingSyncResponse', null, global);
goog.exportSymbol('proto.TrackingViewerDto', null, global);
goog.exportSymbol('proto.TrackingViewerResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingViewerDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TrackingViewerDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingViewerDto.displayName = 'proto.TrackingViewerDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingViewerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TrackingViewerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingViewerResponse.displayName = 'proto.TrackingViewerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingSessionDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.TrackingSessionDto.repeatedFields_, null);
};
goog.inherits(proto.TrackingSessionDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingSessionDto.displayName = 'proto.TrackingSessionDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingLocationDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TrackingLocationDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingLocationDto.displayName = 'proto.TrackingLocationDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingSyncResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.TrackingSyncResponse.repeatedFields_, null);
};
goog.inherits(proto.TrackingSyncResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingSyncResponse.displayName = 'proto.TrackingSyncResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingLocationDelta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TrackingLocationDelta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingLocationDelta.displayName = 'proto.TrackingLocationDelta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingLocationDeltaList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.TrackingLocationDeltaList.repeatedFields_, null);
};
goog.inherits(proto.TrackingLocationDeltaList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingLocationDeltaList.displayName = 'proto.TrackingLocationDeltaList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingViewerDto.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingViewerDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingViewerDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingViewerDto.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
phonenumber: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingViewerDto}
 */
proto.TrackingViewerDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingViewerDto;
  return proto.TrackingViewerDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingViewerDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingViewerDto}
 */
proto.TrackingViewerDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingViewerDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingViewerDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingViewerDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingViewerDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.TrackingViewerDto.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingViewerDto} returns this
 */
proto.TrackingViewerDto.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.TrackingViewerDto.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrackingViewerDto} returns this
 */
proto.TrackingViewerDto.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phoneNumber = 3;
 * @return {string}
 */
proto.TrackingViewerDto.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrackingViewerDto} returns this
 */
proto.TrackingViewerDto.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingViewerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingViewerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingViewerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingViewerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
updateddate: (f = msg.getUpdateddate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
phonenumber: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingViewerResponse}
 */
proto.TrackingViewerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingViewerResponse;
  return proto.TrackingViewerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingViewerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingViewerResponse}
 */
proto.TrackingViewerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingViewerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingViewerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingViewerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingViewerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.TrackingViewerResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrackingViewerResponse} returns this
 */
proto.TrackingViewerResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Timestamp updatedDate = 2;
 * @return {?proto.Timestamp}
 */
proto.TrackingViewerResponse.prototype.getUpdateddate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 2));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.TrackingViewerResponse} returns this
*/
proto.TrackingViewerResponse.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.TrackingViewerResponse} returns this
 */
proto.TrackingViewerResponse.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.TrackingViewerResponse.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.TrackingViewerResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrackingViewerResponse} returns this
 */
proto.TrackingViewerResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phoneNumber = 4;
 * @return {string}
 */
proto.TrackingViewerResponse.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrackingViewerResponse} returns this
 */
proto.TrackingViewerResponse.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.TrackingSessionDto.repeatedFields_ = [1,2,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingSessionDto.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingSessionDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingSessionDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingSessionDto.toObject = function(includeInstance, msg) {
  var f, obj = {
viewerstoaddList: jspb.Message.toObjectList(msg.getViewerstoaddList(),
    proto.TrackingViewerDto.toObject, includeInstance),
viewerstoremoveList: jspb.Message.toObjectList(msg.getViewerstoremoveList(),
    proto.TrackingViewerDto.toObject, includeInstance),
longitude: jspb.Message.getFieldWithDefault(msg, 3, 0),
latitude: jspb.Message.getFieldWithDefault(msg, 4, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
event: jspb.Message.getFieldWithDefault(msg, 6, 0),
viewersList: jspb.Message.toObjectList(msg.getViewersList(),
    proto.TrackingViewerDto.toObject, includeInstance),
altitude: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingSessionDto}
 */
proto.TrackingSessionDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingSessionDto;
  return proto.TrackingSessionDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingSessionDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingSessionDto}
 */
proto.TrackingSessionDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.TrackingViewerDto;
      reader.readMessage(value,proto.TrackingViewerDto.deserializeBinaryFromReader);
      msg.addViewerstoadd(value);
      break;
    case 2:
      var value = new proto.TrackingViewerDto;
      reader.readMessage(value,proto.TrackingViewerDto.deserializeBinaryFromReader);
      msg.addViewerstoremove(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setLongitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setLatitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    case 6:
      var value = /** @type {!proto.TrackingSessionEvent} */ (reader.readEnum());
      msg.setEvent(value);
      break;
    case 7:
      var value = new proto.TrackingViewerDto;
      reader.readMessage(value,proto.TrackingViewerDto.deserializeBinaryFromReader);
      msg.addViewers(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setAltitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingSessionDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingSessionDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingSessionDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingSessionDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewerstoaddList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.TrackingViewerDto.serializeBinaryToWriter
    );
  }
  f = message.getViewerstoremoveList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.TrackingViewerDto.serializeBinaryToWriter
    );
  }
  f = message.getLongitude();
  if (f !== 0) {
    writer.writeSint32(
      3,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0) {
    writer.writeSint32(
      4,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      5,
      f
    );
  }
  f = message.getEvent();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getViewersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.TrackingViewerDto.serializeBinaryToWriter
    );
  }
  f = message.getAltitude();
  if (f !== 0) {
    writer.writeSint32(
      8,
      f
    );
  }
};


/**
 * repeated TrackingViewerDto viewersToAdd = 1;
 * @return {!Array<!proto.TrackingViewerDto>}
 */
proto.TrackingSessionDto.prototype.getViewerstoaddList = function() {
  return /** @type{!Array<!proto.TrackingViewerDto>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.TrackingViewerDto, 1));
};


/**
 * @param {!Array<!proto.TrackingViewerDto>} value
 * @return {!proto.TrackingSessionDto} returns this
*/
proto.TrackingSessionDto.prototype.setViewerstoaddList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.TrackingViewerDto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrackingViewerDto}
 */
proto.TrackingSessionDto.prototype.addViewerstoadd = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.TrackingViewerDto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.clearViewerstoaddList = function() {
  return this.setViewerstoaddList([]);
};


/**
 * repeated TrackingViewerDto viewersToRemove = 2;
 * @return {!Array<!proto.TrackingViewerDto>}
 */
proto.TrackingSessionDto.prototype.getViewerstoremoveList = function() {
  return /** @type{!Array<!proto.TrackingViewerDto>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.TrackingViewerDto, 2));
};


/**
 * @param {!Array<!proto.TrackingViewerDto>} value
 * @return {!proto.TrackingSessionDto} returns this
*/
proto.TrackingSessionDto.prototype.setViewerstoremoveList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.TrackingViewerDto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrackingViewerDto}
 */
proto.TrackingSessionDto.prototype.addViewerstoremove = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.TrackingViewerDto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.clearViewerstoremoveList = function() {
  return this.setViewerstoremoveList([]);
};


/**
 * optional sint32 longitude = 3;
 * @return {number}
 */
proto.TrackingSessionDto.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional sint32 latitude = 4;
 * @return {number}
 */
proto.TrackingSessionDto.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional fixed32 timestamp = 5;
 * @return {number}
 */
proto.TrackingSessionDto.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional TrackingSessionEvent event = 6;
 * @return {!proto.TrackingSessionEvent}
 */
proto.TrackingSessionDto.prototype.getEvent = function() {
  return /** @type {!proto.TrackingSessionEvent} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.TrackingSessionEvent} value
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.setEvent = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated TrackingViewerDto viewers = 7;
 * @return {!Array<!proto.TrackingViewerDto>}
 */
proto.TrackingSessionDto.prototype.getViewersList = function() {
  return /** @type{!Array<!proto.TrackingViewerDto>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.TrackingViewerDto, 7));
};


/**
 * @param {!Array<!proto.TrackingViewerDto>} value
 * @return {!proto.TrackingSessionDto} returns this
*/
proto.TrackingSessionDto.prototype.setViewersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.TrackingViewerDto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrackingViewerDto}
 */
proto.TrackingSessionDto.prototype.addViewers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.TrackingViewerDto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.clearViewersList = function() {
  return this.setViewersList([]);
};


/**
 * optional sint32 altitude = 8;
 * @return {number}
 */
proto.TrackingSessionDto.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingSessionDto} returns this
 */
proto.TrackingSessionDto.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingLocationDto.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingLocationDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingLocationDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingLocationDto.toObject = function(includeInstance, msg) {
  var f, obj = {
longitude: jspb.Message.getFieldWithDefault(msg, 1, 0),
latitude: jspb.Message.getFieldWithDefault(msg, 2, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
altitude: jspb.Message.getFieldWithDefault(msg, 4, 0),
speedoverground: jspb.Message.getFieldWithDefault(msg, 5, 0),
courseoverground: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingLocationDto}
 */
proto.TrackingLocationDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingLocationDto;
  return proto.TrackingLocationDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingLocationDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingLocationDto}
 */
proto.TrackingLocationDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setLongitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setAltitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSpeedoverground(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCourseoverground(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingLocationDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingLocationDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingLocationDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingLocationDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLongitude();
  if (f !== 0) {
    writer.writeSint32(
      1,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      3,
      f
    );
  }
  f = message.getAltitude();
  if (f !== 0) {
    writer.writeSint32(
      4,
      f
    );
  }
  f = message.getSpeedoverground();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getCourseoverground();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional sint32 longitude = 1;
 * @return {number}
 */
proto.TrackingLocationDto.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDto} returns this
 */
proto.TrackingLocationDto.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint32 latitude = 2;
 * @return {number}
 */
proto.TrackingLocationDto.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDto} returns this
 */
proto.TrackingLocationDto.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional fixed32 timestamp = 3;
 * @return {number}
 */
proto.TrackingLocationDto.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDto} returns this
 */
proto.TrackingLocationDto.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional sint32 altitude = 4;
 * @return {number}
 */
proto.TrackingLocationDto.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDto} returns this
 */
proto.TrackingLocationDto.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 speedOverGround = 5;
 * @return {number}
 */
proto.TrackingLocationDto.prototype.getSpeedoverground = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDto} returns this
 */
proto.TrackingLocationDto.prototype.setSpeedoverground = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 courseOverGround = 6;
 * @return {number}
 */
proto.TrackingLocationDto.prototype.getCourseoverground = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDto} returns this
 */
proto.TrackingLocationDto.prototype.setCourseoverground = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.TrackingSyncResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingSyncResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingSyncResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingSyncResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingSyncResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
viewersList: jspb.Message.toObjectList(msg.getViewersList(),
    proto.TrackingViewerResponse.toObject, includeInstance),
nextcursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
hasmore: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingSyncResponse}
 */
proto.TrackingSyncResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingSyncResponse;
  return proto.TrackingSyncResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingSyncResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingSyncResponse}
 */
proto.TrackingSyncResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.TrackingViewerResponse;
      reader.readMessage(value,proto.TrackingViewerResponse.deserializeBinaryFromReader);
      msg.addViewers(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextcursor(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasmore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingSyncResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingSyncResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingSyncResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingSyncResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.TrackingViewerResponse.serializeBinaryToWriter
    );
  }
  f = message.getNextcursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHasmore();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated TrackingViewerResponse viewers = 1;
 * @return {!Array<!proto.TrackingViewerResponse>}
 */
proto.TrackingSyncResponse.prototype.getViewersList = function() {
  return /** @type{!Array<!proto.TrackingViewerResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.TrackingViewerResponse, 1));
};


/**
 * @param {!Array<!proto.TrackingViewerResponse>} value
 * @return {!proto.TrackingSyncResponse} returns this
*/
proto.TrackingSyncResponse.prototype.setViewersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.TrackingViewerResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrackingViewerResponse}
 */
proto.TrackingSyncResponse.prototype.addViewers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.TrackingViewerResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrackingSyncResponse} returns this
 */
proto.TrackingSyncResponse.prototype.clearViewersList = function() {
  return this.setViewersList([]);
};


/**
 * optional string nextCursor = 2;
 * @return {string}
 */
proto.TrackingSyncResponse.prototype.getNextcursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrackingSyncResponse} returns this
 */
proto.TrackingSyncResponse.prototype.setNextcursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool hasMore = 3;
 * @return {boolean}
 */
proto.TrackingSyncResponse.prototype.getHasmore = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.TrackingSyncResponse} returns this
 */
proto.TrackingSyncResponse.prototype.setHasmore = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingLocationDelta.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingLocationDelta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingLocationDelta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingLocationDelta.toObject = function(includeInstance, msg) {
  var f, obj = {
longitudedelta: jspb.Message.getFieldWithDefault(msg, 1, 0),
latitudedelta: jspb.Message.getFieldWithDefault(msg, 2, 0),
timestampdelta: jspb.Message.getFieldWithDefault(msg, 3, 0),
altitudedelta: jspb.Message.getFieldWithDefault(msg, 4, 0),
speedovergrounddelta: jspb.Message.getFieldWithDefault(msg, 5, 0),
courseovergrounddelta: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingLocationDelta}
 */
proto.TrackingLocationDelta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingLocationDelta;
  return proto.TrackingLocationDelta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingLocationDelta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingLocationDelta}
 */
proto.TrackingLocationDelta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setLongitudedelta(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setLatitudedelta(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setTimestampdelta(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setAltitudedelta(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setSpeedovergrounddelta(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setCourseovergrounddelta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingLocationDelta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingLocationDelta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingLocationDelta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingLocationDelta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLongitudedelta();
  if (f !== 0) {
    writer.writeSint32(
      1,
      f
    );
  }
  f = message.getLatitudedelta();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
  f = message.getTimestampdelta();
  if (f !== 0) {
    writer.writeSint32(
      3,
      f
    );
  }
  f = message.getAltitudedelta();
  if (f !== 0) {
    writer.writeSint32(
      4,
      f
    );
  }
  f = message.getSpeedovergrounddelta();
  if (f !== 0) {
    writer.writeSint32(
      5,
      f
    );
  }
  f = message.getCourseovergrounddelta();
  if (f !== 0) {
    writer.writeSint32(
      6,
      f
    );
  }
};


/**
 * optional sint32 longitudeDelta = 1;
 * @return {number}
 */
proto.TrackingLocationDelta.prototype.getLongitudedelta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDelta} returns this
 */
proto.TrackingLocationDelta.prototype.setLongitudedelta = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint32 latitudeDelta = 2;
 * @return {number}
 */
proto.TrackingLocationDelta.prototype.getLatitudedelta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDelta} returns this
 */
proto.TrackingLocationDelta.prototype.setLatitudedelta = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional sint32 timestampDelta = 3;
 * @return {number}
 */
proto.TrackingLocationDelta.prototype.getTimestampdelta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDelta} returns this
 */
proto.TrackingLocationDelta.prototype.setTimestampdelta = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional sint32 altitudeDelta = 4;
 * @return {number}
 */
proto.TrackingLocationDelta.prototype.getAltitudedelta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDelta} returns this
 */
proto.TrackingLocationDelta.prototype.setAltitudedelta = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional sint32 speedOverGroundDelta = 5;
 * @return {number}
 */
proto.TrackingLocationDelta.prototype.getSpeedovergrounddelta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDelta} returns this
 */
proto.TrackingLocationDelta.prototype.setSpeedovergrounddelta = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional sint32 courseOverGroundDelta = 6;
 * @return {number}
 */
proto.TrackingLocationDelta.prototype.getCourseovergrounddelta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingLocationDelta} returns this
 */
proto.TrackingLocationDelta.prototype.setCourseovergrounddelta = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.TrackingLocationDeltaList.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingLocationDeltaList.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingLocationDeltaList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingLocationDeltaList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingLocationDeltaList.toObject = function(includeInstance, msg) {
  var f, obj = {
baselocation: (f = msg.getBaselocation()) && proto.TrackingLocationDto.toObject(includeInstance, f),
deltasList: jspb.Message.toObjectList(msg.getDeltasList(),
    proto.TrackingLocationDelta.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingLocationDeltaList}
 */
proto.TrackingLocationDeltaList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingLocationDeltaList;
  return proto.TrackingLocationDeltaList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingLocationDeltaList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingLocationDeltaList}
 */
proto.TrackingLocationDeltaList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.TrackingLocationDto;
      reader.readMessage(value,proto.TrackingLocationDto.deserializeBinaryFromReader);
      msg.setBaselocation(value);
      break;
    case 2:
      var value = new proto.TrackingLocationDelta;
      reader.readMessage(value,proto.TrackingLocationDelta.deserializeBinaryFromReader);
      msg.addDeltas(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingLocationDeltaList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingLocationDeltaList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingLocationDeltaList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingLocationDeltaList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBaselocation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.TrackingLocationDto.serializeBinaryToWriter
    );
  }
  f = message.getDeltasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.TrackingLocationDelta.serializeBinaryToWriter
    );
  }
};


/**
 * optional TrackingLocationDto baseLocation = 1;
 * @return {?proto.TrackingLocationDto}
 */
proto.TrackingLocationDeltaList.prototype.getBaselocation = function() {
  return /** @type{?proto.TrackingLocationDto} */ (
    jspb.Message.getWrapperField(this, proto.TrackingLocationDto, 1));
};


/**
 * @param {?proto.TrackingLocationDto|undefined} value
 * @return {!proto.TrackingLocationDeltaList} returns this
*/
proto.TrackingLocationDeltaList.prototype.setBaselocation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.TrackingLocationDeltaList} returns this
 */
proto.TrackingLocationDeltaList.prototype.clearBaselocation = function() {
  return this.setBaselocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.TrackingLocationDeltaList.prototype.hasBaselocation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TrackingLocationDelta deltas = 2;
 * @return {!Array<!proto.TrackingLocationDelta>}
 */
proto.TrackingLocationDeltaList.prototype.getDeltasList = function() {
  return /** @type{!Array<!proto.TrackingLocationDelta>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.TrackingLocationDelta, 2));
};


/**
 * @param {!Array<!proto.TrackingLocationDelta>} value
 * @return {!proto.TrackingLocationDeltaList} returns this
*/
proto.TrackingLocationDeltaList.prototype.setDeltasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.TrackingLocationDelta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrackingLocationDelta}
 */
proto.TrackingLocationDeltaList.prototype.addDeltas = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.TrackingLocationDelta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrackingLocationDeltaList} returns this
 */
proto.TrackingLocationDeltaList.prototype.clearDeltasList = function() {
  return this.setDeltasList([]);
};


/**
 * @enum {number}
 */
proto.TrackingSessionEvent = {
  TRACKINGSESSIONEVENTNONE: 0,
  TRACKINGSESSIONEVENTENABLE: 1,
  TRACKINGSESSIONEVENTDISABLE: 2
};

goog.object.extend(exports, proto);
